import React from 'react';
import { DataInput } from '../../screens/Profile/data-input/DataInput';
import { ValidatedDataInputProps } from './ValidatedDataInput';
import { FacultyDataKeys } from '../../screens/Profile/FacultyDataKeys';
import { isInstitutionCityValid, ValidatorResponse } from './Validator';

export const TEST_ID = {
  INPUT_INSTITUTION_CITY: '506D43C0-BEBB-45C4-918B-AA5E292B2205'
};
export const minLength = 2;
export const maxLength = 50;

export interface InstitutionCityInputProps extends ValidatedDataInputProps {}

export const InstitutionCityInput: React.FC<InstitutionCityInputProps> = props => {
  const { whenValidated } = props;
  return (
    <DataInput
      validator={async (value: string) => {
        const isValid: ValidatorResponse = isInstitutionCityValid(value);
        if (!isValid.response) {
          whenValidated?.(false);
          throw new Error(isValid.reason);
        }
        whenValidated?.(true);
      }}
      // Mark this as a guaranteed value (defaultProp) so that TS is happy
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dataLabel={props.dataLabel!}
      {...props}
    />
  );
};

InstitutionCityInput.defaultProps = {
  dataLabel: 'Institution City',
  name: FacultyDataKeys.entityCity,
  testId: TEST_ID.INPUT_INSTITUTION_CITY,
  required: true,
  helperMessage: `${maxLength} characters allowed`,
  whenValidated: () => { return; }
};
